import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

export interface LoginErrorProps {
    contactInfo: {
        name: string;
        email: string;
        phone: string;
    };
}

const LoginError = ({ contactInfo }: LoginErrorProps) => (
    <div className="max-w-[60%] leading-[20px] mt-4">
        <div>FEIL PASSORD / IKKE REGISTRERT</div>
        <div className="text-red-500">
            <div>Brukernavn eller passord stemmer ikke. Prøv igjen.</div>
            <div>
                Vennligst kontakt {contactInfo.name} på e-post{' '}
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a> eller telefon {contactInfo.phone} dersom
                du behøver hjelp
            </div>
        </div>
    </div>
);

const LoginErrorWithStore = () => {
    const { loginPageStore } = getStore();
    return <LoginError contactInfo={loginPageStore.errorContactInfo} />;
};

export default observer(LoginErrorWithStore);
